import { Suspense, useEffect, useState } from "react";
import Breadcrumb from "../../../helper/Breadcrumb";
import Spinner from "../../../Components/spinner";
import dateformate from "../../../helper/DateFormate";
import { ActionButton, PlusButton } from "../../../helper/ImageFormat";
import { deleteItem, fetchData } from "../../../utils/apiUtils";
import CustomPagination from "../../../helper/Pagination";
import DeleteModel from "../../../Components/DeleteModel";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import AddPage from "./AddPage";
const PagePermission = () => {
 const [loading, setLoading] = useState(false);
 const [data, setData] = useState([]);
 const [deleteItemId, setDeleteItemId] = useState({});
 const [isDeleting, setIsDeleting] = useState(false);
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [perPage, setPerPage] = useState(10);
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const [search, setSearch] = useState("");
 const [editData, setEditData] = useState({});
 const fetchPaginationData = async (page = 1, searchQuery = "") => {
  const requestData = {
   perPage: perPage,
   pageNo: page,
   search: searchQuery,
  };
  await fetchData(
   "page-pagination",
   requestData,
   setData,
   setTotalCount,
   setCurrentPage,
   setLoading
  );
  setEditData({})
 };

 useEffect(() => {
  const delay = search ? 500 : 0;
  const handler = setTimeout(() => {
   fetchPaginationData(currentPage, search);
  }, delay);
  return () => clearTimeout(handler);
 }, [search, perPage]);

 const totalPages = Math.ceil(totalCount / perPage);
 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   fetchPaginationData(page);
  }
 };

 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Page", path: "*" },
 ];

 const handleDelete = async (data) => {
  setDeleteItemId(data);
  setDeleteModalOpen(true);
 };

 const handleEditClick = (item) => {
setEditData(item);
 };
 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem("page", deleteItemId?.id, fetchPaginationData);
   setDeleteItemId({});
   setDeleteModalOpen(false);
   return res;
  } catch (error) {
   return error;
  } finally {
   setIsDeleting(false);
  }
 };

 const Tableheader = ["Page Name", "Page Action", "Action"];
 return (
  <div className="content-wrapper">
   <div className="page-header mt-5 d-flex justify-content-between">
    <h3 className="custom-page-title">Page</h3>
    <Breadcrumb items={breadcrumbdata} />
   </div>

   <div
    className="d-flex justify-content-between mb-2 bg-white p-2"
    style={{ marginTop: "-20px" }}
   >
    <PerPageSelect value={perPage} onChange={setPerPage} />
    <div style={{ display: "flex", gap: "10px" }}>
     <TableSearch value={search} onChange={setSearch} />
     <PlusButton module={"Add"} />
    </div>
   </div>
   <div>
    <AddPage fetchPaginationData={fetchPaginationData} editData={editData}/>
   </div>
   <div className="row" style={{ marginTop: "10px" }}>
    <div className="col-md-12 grid-margin stretch-card">
     <div className="card">
      <div className="card-body">
       <div className="table-responsive ">
        <table
         className=" custom-table table table-striped"
         id="pagewiseBannerTable"
        >
         <thead>
          <tr>
           {Tableheader &&
            Tableheader.length > 0 &&
            Tableheader.map((item, index) => (
             <th className="font-weight-bold" key={index}>
              {item}
             </th>
            ))}
          </tr>
         </thead>

         <tbody>
          {loading ? (
           <tr>
            <td colSpan="12" className="text-center">
             <Spinner />
            </td>
           </tr>
          ) : data.length > 0 ? (
           data.map((item, index) => {
            return (
             <tr key={index}>
              <td>{item?.pageName}</td>
              <td>
               <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {item?.action?.map((act, i) => {
                   const actionClass = act.toLowerCase().replace(" ", "-");
                 return (
        <span
          key={index}
          className={`custom-status-badge badge-${actionClass}`}
        >
          {act}
        </span>
      );
                })}
               </div>
              </td>
              <td>{dateformate(item.updatedAt)}</td>
              <td>
               <ActionButton
                data={item}
                handleEditClick={handleEditClick}
                handleDelete={handleDelete}
                module={"Page"}
               />
              </td>
             </tr>
            );
           })
          ) : (
           <tr>
            <td colSpan="12" className="text-center">
             <h5>No data found.</h5>
            </td>
           </tr>
          )}
         </tbody>
        </table>
       </div>

       {data.length > 0 && (
        <div>
         <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageClick}
          perPage={perPage}
          totalCount={totalCount}
         />
        </div>
       )}
      </div>
     </div>
    </div>

    {deleteModalOpen && (
     <Suspense fallback={null}>
      <DeleteModel
       deleteModalOpen={deleteModalOpen}
       setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
       onConfirm={confirmDelete}
       itemName="Page permission"
       isDeleting={isDeleting}
      />
     </Suspense>
    )}
   </div>
  </div>
 );
};

export default PagePermission;
